var React = require('react');

function ContinuousMode (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.477 3.979A1.5 1.5 0 0 0 8 5.5v12c0 2.468 2.032 4.5 4.5 4.5h23c2.468 0 4.5-2.032 4.5-4.5v-12a1.5 1.5 0 1 0-3 0v12c0 .846-.654 1.5-1.5 1.5h-23c-.846 0-1.5-.654-1.5-1.5v-12a1.5 1.5 0 0 0-1.523-1.521zM15.5 4a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 1 0 0-3h-17zm0 7a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 1 0 0-3h-17zm-3 15C10.032 26 8 28.032 8 30.5v12a1.5 1.5 0 1 0 3 0v-12c0-.846.654-1.5 1.5-1.5h23c.846 0 1.5.654 1.5 1.5v12a1.5 1.5 0 1 0 3 0v-12c0-2.468-2.032-4.5-4.5-4.5h-23zm3 8a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 1 0 0-3h-17zm0 7a1.5 1.5 0 1 0 0 3h17a1.5 1.5 0 1 0 0-3h-17z"}));
}

ContinuousMode.defaultProps = {"viewBox":"0 0 48 48","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = ContinuousMode;

ContinuousMode.default = ContinuousMode;
